import ElementBase from "./ElementBase";
import Element from "./Element";
import { getDefaultTranslationProvider } from "../translation/TranslationProvider";
// import TranslationProvider from "../translation/TranslationProvider";

export default class XMLRDBNavigation extends ElementBase {
  /**
   * @param {Element} rootNode
   * @param { '../translation/TranslationProvider' | undefined} translationProvider
   */
  constructor(rootNode, translationProvider = undefined) {
    super(rootNode);

    if(translationProvider === undefined) {
     this.translationProvider = getDefaultTranslationProvider();
    }
    else{
      this.translationProvider = translationProvider;
    }
  }

  static async getNavigation(rootNode, translationProvider) {
    let nav = new XMLRDBNavigation(rootNode, translationProvider);
    await nav.init(rootNode);
    return nav;
  }

  async init(rootNode) {
    this.elements = new Map();

    rootNode.querySelectorAll("Element").forEach(node => {
      let elem = new Element(node, this);
      this.elements.set(elem.id(), elem);
      if (!elem.parent())
        this.children.push(elem);
    });
  }

  /**
   *
   * @param {String} id
   * @returns {Element}
   */
  getElement(id) {
    return this.elements.get(id);
  }

  /**
   * @param {String} aName
   * @returns Array aller Elemente, die den angegebenen Namen tragen und nicht Lookups sind
   */
  getElementsByName(aName) {
    let result = [];
    for (let [k, v] of this.elements.entries()) {
      if (!v.isLookup() && v.name() === aName)
        result.push(v);
    }
    return result;
  }

  /**
   * @returns Array aller Elementnamen, die nicht Lookups sind
   */
  getElementNames() {
    let result = [];
    for (let [k, v] of this.elements.entries()) {
      if (!v.isLookup())
        result.push(v.name());
    }
    return result;
  }
}